/* eslint global-require: off */
const ENV_CONSTANTS = {
	dev: {
		ENV: 'dev',
		SERVICE_URL: 'https://bohostones.herokuapp.com'
	},
	beta: {
		ENV: 'beta',
		SERVICE_URL: 'https://bohostones.herokuapp.com'
	},
	prod: {
		ENV: 'prod',
		SERVICE_URL: 'https://bohostones.herokuapp.com'
	}
};

/* eslint import/no-unresolved: [2, { ignore: ['\.config.local.js$'] }] */
if (ENV === 'local' || ENV === 'test') {
	ENV_CONSTANTS[ENV] = require('../../.config.local.js').default;
}

export default Object.assign(ENV_CONSTANTS[ENV], {
	TEST: 'test',

	RESPONSIVE_XS: 400,
	RESPONSIVE_SM: 900,
	RESPONSIVE_MD: 1200,
	RESPONSIVE_LG: 1400
});
